import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import adminApi, { ADMIN_TOKEN_KEY } from "./adminApi";

const AdminAuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (!token) { setAdmin(null); setLoading(false); return; }
    try {
      const { data } = await adminApi.get("/admin/auth/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      setAdmin(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (identifier, password, access_code) => {
    const { data } = await adminApi.post("/admin/auth/login", { identifier, password, access_code });
    localStorage.setItem(ADMIN_TOKEN_KEY, data.token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    setAdmin(null);
    window.location.href = "/back-office/login";
  };

  return (
    <AdminAuthCtx.Provider value={{ admin, loading, login, logout, refresh }}>
      {children}
    </AdminAuthCtx.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthCtx);
